import React from 'react';
import Allies from '../components/Allies';
import Footer from '../components/Footer';

const AlliancesPage = () => {
  return (
    <div className="min-h-screen">
      <section className="py-20 bg-gradient-to-br from-fhk-cyan-50 to-fhk-orange-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Alianzas
            </h1>
           
          </div>
        </div>
      </section>
      <Allies />
      <Footer />
    </div>
  );
};

export default AlliancesPage;
